import React from "react";

export default function Header() {
    return(
        <div className="main">
            <div className="header">
                <h2>SPLI<br></br>TTER</h2>
            </div>
        </div>
    );
}